import { consts } from '../constants';

export const auth = {
  isAuthenticated,
  getToken,
  setToken,
  setRefreshToken,
  getRefreshToken,
  clearToken
};

function isAuthenticated() {
  return !!getToken();
}

function getToken() {
  return sessionStorage.getItem(consts.TOKEN_KEY) || localStorage.getItem(consts.TOKEN_KEY);
}

function setToken({ token, rememberMe = false }) {
  if (rememberMe) {
    localStorage.setItem(consts.TOKEN_KEY, token);
  } else {
    sessionStorage.setItem(consts.TOKEN_KEY, token);
  }
}

function setRefreshToken(token) {
  if (token) {
    localStorage.setItem(consts.REFRESH_KEY, token);
  }
}

function getRefreshToken() {
  return localStorage.getItem(consts.REFRESH_KEY);
}

async function clearToken() {
  localStorage.removeItem(consts.TOKEN_KEY);
  sessionStorage.removeItem(consts.TOKEN_KEY);
}
